import { urlUtil } from '@cmg/common';

/**
 * All routePath values here are relative to the "/offering-side-panel/:offeringId" segment
 * (see hooks/useOfferingSidePanelMatch.ts for why that segment can't be expressed as a v6 route
 * pattern) and are matched via `matchPath` against that hook's `rest` field, not through a
 * `<Routes>` tree.
 */

const offeringDetails = {
  routePath: `/details`,
  getUrlPath: () => `/details`,
};

const offeringSummary = {
  routePath: `/summary`,
  getUrlPath: () => `/summary`,
};

const orderBook = {
  routePath: `/order-book`,
  getUrlPath: () => '/order-book',
};

const orderBookNewIndication = {
  routePath: `${orderBook.routePath}/indication-activity/new`,
  getUrlPath: () => {
    return '/order-book/indication-activity/new';
  },
};

const orderBookUpdateHistory = {
  routePath: `${orderBook.routePath}/update-history`,
  getUrlPath: (props: { cmgEntityKey: string }) => {
    return `/order-book/update-history${urlUtil.queryStringify({
      cmgEntityKey: props.cmgEntityKey,
    })}`;
  },
};

const orderBookIndicationActivity = {
  routePath: `${orderBook.routePath}/indication-activity`,
  getUrlPath: (props?: { cmgEntityKey: string }) => {
    const queryParam = props?.cmgEntityKey
      ? urlUtil.queryStringify({ cmgEntityKey: props.cmgEntityKey })
      : '';

    return `/order-book/indication-activity${queryParam}`;
  },
};

const orderBookCompliance = {
  routePath: `${orderBook.routePath}/compliance`,
  getUrlPath: () => `/order-book/compliance`,
};

const internalDemand = {
  routePath: `${orderBook.routePath}/my-internal-demand`,
  getUrlPath: () => '/order-book/my-internal-demand',
};

const orderAllocation = {
  routePath: `/order-allocation`,
  getUrlPath: () => `/order-allocation`,
};

const communicatedDemand = {
  routePath: `${orderAllocation.routePath}/communicated-demand`,
  getUrlPath: () => '/order-allocation/communicated-demand',
};

const offeringNotes = {
  routePath: `/offering_notes`,
  getUrlPath: () => `/offering_notes`,
};

const offeringSidePanelBuySideRoutes = {
  offeringDetails,
  offeringSummary,
  orderBook,
  orderBookNewIndication,
  orderBookUpdateHistory,
  orderBookIndicationActivity,
  orderBookCompliance,
  orderAllocation,
  communicatedDemand,
  internalDemand,
  offeringNotes,
};

export default offeringSidePanelBuySideRoutes;
